/* unplugin-vue-components disabled */import script from "./Board.vue?vue&type=script&setup=true&lang=js"
export * from "./Board.vue?vue&type=script&setup=true&lang=js"

import "./Board.vue?vue&type=style&index=0&id=f2df1a48&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2df1a48"]])

export default __exports__